import {observer} from "mobx-react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import PublicIcon from '@mui/icons-material/Public';
import CloseIcon from "@mui/icons-material/Close";
import Accordion from "../../models/Accordion";
import {useStore} from "../../stores/Store";
import React, {useState} from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {EntityStatus} from "../../models/EntityStatus";
import ConfirmationDialog from "../Misc/ConfirmationDialog/ConfirmationDialog";

interface Props {
    accordion: Accordion
}

export default observer(function AccordionPublishDialog({accordion}:Props){
    const { LanguageStore, AccordionStore } = useStore();
    const { currentLanguageMessages } = LanguageStore;
    const { update } = AccordionStore;
    const handlePublishClick = () => {
        update({...accordion, status: EntityStatus.created})
    }

    return (
        <ConfirmationDialog
            confirmationTitle={currentLanguageMessages.AccordionsPage.PublishAccordion.ConfirmationDialogTitle}
            confirmationText={currentLanguageMessages.AccordionsPage.PublishAccordion.ConfirmationDialogContent}
            buttonLabel={currentLanguageMessages.GeneralComponentLabels.publishButtonLabel}
            buttonIcon={<PublicIcon />}
            confirmCallback={handlePublishClick}
            buttonColor={'info'}
        />
    )
})